import { render } from "./LocaleChange.vue?vue&type=template&id=16a159bd&scoped=true"
const script = {}

import "./LocaleChange.vue?vue&type=style&index=0&id=16a159bd&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a159bd"]])

export default __exports__